export default function header() {

    const burgers = document.querySelectorAll('.js-burger');
    const mobileMenu = document.querySelector('.js-mobile-menu');
    const mobileMenuClose = document.querySelector('.js-mobile-menu-close');
    const mobileMenuLinks = document.querySelectorAll('.js-mobile-menu-link');
    const header = document.querySelector('.header');
    let distance = 0;

    function lockScroll() {
        distance = window.scrollY;
        document.body.style.top = `-${distance}px`;
        document.body.classList.add('dis-scroll');
    }

    function unlockScroll() {
        if (!document.body.classList.contains('dis-scroll')) return;

        document.body.classList.remove('dis-scroll');
        document.body.style.top = '';
        window.scrollTo({ top: distance, left: 0, behavior: 'instant' });
    }

    function closeMenu() {
        burgers.forEach(burger => burger.classList.remove('active'));
        mobileMenu.classList.remove('active');
        unlockScroll();
    }

    if(burgers.length > 0){

        burgers.forEach(burger => {
            burger.addEventListener('click', () => {
                if (mobileMenu.classList.contains('active')) {
                    closeMenu();
                    return;
                }

                burger.classList.add('active');
                mobileMenu.classList.add('active');
                lockScroll();
            });
        });

    }

    if(mobileMenuClose){
        mobileMenuClose.addEventListener('click', closeMenu);
    }

    if(mobileMenuLinks.length > 0){
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });
    }

    if (header){
        if (window.innerWidth < 768){
            document.addEventListener('scroll', () => {
                if (window.scrollY > 100){
                    header.style.opacity = 1;
                } else {
                    header.style.opacity = 0;
                }
            });
        }
    }

}
